import { FETCH_CURRENT_USER } from "./types";

const INITIAL_STATE = {
  currentUser: {
    user: undefined,
    loading: false,
    error: null,
  },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // --------------------------------------------------------------------------
    // FETCH_CURRENT_USER
    // --------------------------------------------------------------------------
    case FETCH_CURRENT_USER.init:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          error: action.payload.data || { message: action.payload.message },
          loading: true,
        },
      };
    case FETCH_CURRENT_USER.success:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          user: action.payload,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    case FETCH_CURRENT_USER.failure:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          user: undefined,
          error: action.payload.data || { message: action.payload.message },
          loading: false,
        },
      };
    default:
      return state;
  }
};
